// Used as a communications object between UI components
// to toggle note badges on & off
export class NoteExistsStatus {
    constructor(public uuid: string,
                public noteExists: boolean) {
    }
}
